import "fontsource-roboto";
import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Column, Row } from 'simple-flexbox';
import './App.css';
import HeaderComponent from './components/HeaderComponent';
//import {NavBar} from "./navigation/components";
import RouterConfig from "./navigation/RouterConfig";
import { SidebarComponent, SidebarContext } from './navigation/sidebar';



const useStyles = createUseStyles({
  container: {
    height: '100vh',
    // minHeight: 500
  },
  mainBlock: {
    marginLeft: 255,
    '@media (max-width: 1080px)': {
      marginLeft: 0
    },
    wrap: true
  },
  contentBlock: {
    marginTop: 10,
    height: '100%'
  }
});


function App() {
  const theme = useTheme();
  const classes = useStyles({ theme });

  console.log(process.env.NODE_ENV)

  return (
    <SidebarContext>
      <Row className={classes.container}>
        <SidebarComponent />
        <Column flexGrow={1} className={classes.mainBlock}>
          <HeaderComponent />
          <div className={classes.contentBlock}>
            <RouterConfig />
          </div>
        </Column>
      </Row>
    </SidebarContext>
  );
}

export default App;
